<template>
    <div class="timeout-mobile-wrapper">
        <div class="timeout-widget"
            :class="{
                ['timed-out']: timedOut,
                ['alert']: countdownAlert,
                ['clickable']: !activePlayer,
            }"
            @click="openModal()"
        >
            <span class="time-remaining">
                {{timeRemaining}}
            </span>
            <span class="claim-victory" v-if="timeRemaining && timedOut && !activePlayer">
                Claim Victory
            </span>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

const noTimeRemaining = '00:00';

export default {
    props: ['refresh'],
    name: 'Timeout',
    created() {
        this.startCountdown();
    },
    watch: {
        refresh(current, prev) {
            if (current !== prev) {
                this.countdownAlert = false;
                this.refreshTimeout = moment().format();
                this.startCountdown();
            }
        },
        timeRemaining(current, prev) {
            if (current !== prev) {
                this.refreshTimeout = moment().format();
            }
        },
    },
    data() {
        return {
            refreshInterval: null,
            timeRemaining: null,
            refreshTimeout: moment().format(),
            noTimeRemaining,
            countdownAlert: false,
        };
    },
    computed: {
        gameId() {
            return parseInt(this.$route.params.id, 10);
        },
        gameState() {
            return this.$store.state.gameState;
        },
        timeLimit() {
            return this.gameState.timeLimit;
        },
        updatedAt() {
            return this.gameState.updatedAt;
        },
        timedOut() {
            return this.timeRemaining === noTimeRemaining;
        },
        activePlayer() {
            const { activePlayerId } = this.gameState;
            return this.player && this.player.id === activePlayerId;
        },
        player() {
            return this.$store.getters.player;
        },
    },
    methods: {
        getTimeRemaining() {
            const now = moment();
            const lastTurnTime = moment(this.updatedAt);
            const elapsedTimeMs = now.diff(lastTurnTime, 'mins');
            const timeLimitMs = this.timeLimit * 60 * 1000;
            const timeRemainingMs = timeLimitMs - elapsedTimeMs;
            const timeRemainingMins = moment.duration(timeRemainingMs).minutes();
            const timeRemainingSecs = moment.duration(timeRemainingMs).seconds();

            if (timeRemainingMs < 0) {
                return noTimeRemaining;
            }

            if (timeRemainingMs <= 60000 && !this.countdownAlert) {
                this.countdownAlert = true;
            }

            return `${this.padTime(timeRemainingMins)}:${this.padTime(timeRemainingSecs)}`;
        },
        padTime(time) {
            return String(time).length === 1 ? `0${time}` : time;
        },
        startCountdown() {
            const self = this;
            const intervalMs = 1000;

            clearInterval(this.refreshInterval);

            this.refreshInterval = setInterval(() => {
                this.timeRemaining = self.getTimeRemaining();

                if (this.timeRemaining === noTimeRemaining) {
                    clearInterval(this.refreshInterval);
                }
            }, intervalMs);
        },
        openModal() {
            if (this.timedOut && !this.activePlayer) {
                this.$store.dispatch('openModal', { type: 'timeout' });
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .timeout-mobile-wrapper {

        .timeout-widget {
            display: flex;

            .claim-victory {
                cursor: pointer;
                margin-left: 8px;
                white-space: nowrap;
            }

            .claim-victory,
            .time-remaining {
                background: white;
                padding: 3px 6px;
                box-shadow: -1px 1px 1px 1px #b5b5b5;
                border-radius: 4px;
                box-sizing: border-box;
            }

            &.alert,
            &.timed-out {

                .time-remaining {
                    color: $lancer;
                }
            }
        }
    }

    @media only screen and (min-width: $screen-sm) {

    }
</style>
